import { render, staticRenderFns } from "./StatsTableADT.vue?vue&type=template&id=c62f2f7a&scoped=true"
import script from "./StatsTableADT.vue?vue&type=script&lang=js"
export * from "./StatsTableADT.vue?vue&type=script&lang=js"
import style0 from "./StatsTableADT.vue?vue&type=style&index=0&id=c62f2f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f2f7a",
  null
  
)

export default component.exports